import Employee from "models/employee"
import { EmployeeClasses } from "models/employee-class"

// 'departmentLevel' groups by a level of the department hierarchy; which level is carried
// by departmentLevelId. Levels are CRUD-managed data, so they are not enumerated here.
export type BillabilityGroupBy = 'departmentLevel' | 'branch' | 'employee'


export interface ITrendPoint {
    fiscalPeriod: number
    utilizationPct: number
    actualBillablePct: number
    // Company-wide target for the period's fiscal year, null if none is set.
    utilizationTarget: number | null
    actualBillableTarget: number | null
}

// What the page pulls off the trend and hands to the chart to draw its benchmark line.
export interface ITrendTarget {
    fiscalPeriod: number
    utilizationTarget: number | null
    actualBillableTarget: number | null
}

export interface ITrendGroupPoint {
    fiscalPeriod: number
    groupName: string
    // Assigned department colour, null when unset or when grouping by branch.
    groupColor: string | null
    utilizationPct: number
    actualBillablePct: number
}

export interface IBillabilityRow {
    employeeId: string
    employeeName: string
    departmentId: string
    departmentName: string
    branchId: string
    branchName: string
    employeeClassId: string
    hireDate: string | null
    billRatePct: number
    timeAvailable: number
    timeTotal: number
    timeBillable: number
    ramTimeNonBillable: number
    prospectsTimeNonBillable: number
    projxTimeNonBillable: number
    vacationTimeNonBillable: number
    sickTimeNonBillable: number
    statTimeNonBillable: number
    otherNonBillable: number
    billableTarget: number
    utilizationPct: number
    actualBillablePct: number
    nested?: IBillabilityRow[]
}

export interface IBillabilityQuery {
    fromDate?: string   // 'YYYY-MM-DD', inclusive
    toDate?: string     // 'YYYY-MM-DD', inclusive
    employeeClassIds?: string[]
    departmentIds?: string[]
    branchIds?: string[]
    groupBy?: BillabilityGroupBy
    departmentLevelId?: string
    // 'true' / 'false' as strings -- buildQueryString drops falsy array items, so a boolean false would never be sent
    billable?: string[]
}

// The 12 months ending last month, salaried staff, grouped by department level.
// toLocaleDateString('en-CA') gives YYYY-MM-DD in local time.
const today = new Date()
const ymd = (date: Date) => date.toLocaleDateString('en-CA')

export const DEFAULT_BILLABILITY_QUERY: IBillabilityQuery = {
    fromDate: ymd(new Date(today.getFullYear(), today.getMonth() - 12, 1)),
    toDate: ymd(new Date(today.getFullYear(), today.getMonth(), 0)),
    employeeClassIds: [EmployeeClasses.SALARY],
    billable: ['true'],
    groupBy: 'departmentLevel',
}



// Department billable filter. Values are strings because they travel in the query string.
export const BILLABLE_OPTIONS = [
    { value: 'true', label: 'Billable' },
    { value: 'false', label: 'Non-Billable' },
]

export class BillabilityAndUtilizationUI {
    static readonly WARNING_PERCENT = 70

    static billabilityPercentColor(billabilityPercent: number): string {
        // Yellow – Below 70%
        if (billabilityPercent < this.WARNING_PERCENT)
            return "table-warning"

        return ""
    }
}
